<template>
    <tile-question-layout v-if="panel_required"
                             :options_loaded="options_loaded"
                             :passed_filter="passed_filter"
                             :title="title"
                             :loading="loading"
                             v-model:target="localTarget"
                             :filtered_option_list="filtered_option_list"
                             :thumb_url="thumbURL"
                             :component_id="component_id"
                             :fabricator="fabricator"
                             :modifier_class="modifier_class">

    </tile-question-layout>
</template>

<script type="text/ecmascript-6">
    import DesignerQuestionTechnicalThreshold from "../DesignerQuestionTechnicalThreshold.vue";
    import Question from "../mixin/Question.vue";

    export default {
        mixins: [
            DesignerQuestionTechnicalThreshold,
            Question
        ],
        props: {
            component_id: {
                default(){
                    return 'threshold';
                }
            },
            modifier_class: {
                default(){
                    return '_wide';
                }
            },
        },
        computed: {
            thumbURL() {
                return '/thumb/profile/';
            },
        },
    }
</script>
